import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { trackAwinConversion } from '@wizbii/utils/tracking';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AwinService {
  readonly #cookieService = inject(CookieService);

  track(commissionGroupCode: string): void {
    let orderRef: string = this.#cookieService.get(`awin_order_reference`);
    if (!orderRef || orderRef.length === 0) {
      orderRef = btoa(`${Date.now()}`);

      const msIn390Days = 1000 * 3600 * 24 * 390;
      this.#cookieService.set(
        'awin_order_reference',
        orderRef,
        new Date(Date.now() + msIn390Days),
        '/',
        environment.envFqdn,
        true,
        'None'
      );
    }

    const token = this.getAwcToken();

    if (token !== null) {
      setTimeout(() => {
        trackAwinConversion({ orderReference: orderRef, awc: token, commissionGroupCode });
      }, 500);
    }
  }

  private getAwcToken(): string | null {
    const awm = this.#cookieService.get(`_aw_m_${environment.awinMerchantId}`);
    const awsn = this.#cookieService.get(`_aw_sn_${environment.awinMerchantId}`);
    const awc = this.#cookieService.get(`awc`);

    if (awm.length > 0) {
      return awm;
    } else if (awc.length > 0) {
      return awc;
    } else if (awsn.length > 0) {
      return awsn;
    }
    return null;
  }
}
